import { z } from "zod";

export const DashboardOrderKpi = z.object({
  total: z.number(),
  completed: z.number(),
  remaining: z.number(),
  completion_rate: z.number(),
});

export const DashboardDriverKpi = z.object({
  total: z.number(),
  active: z.number(),
});

export const DailyTrendEntry = z.object({
  date: z.string(),
  total: z.number(),
  completed: z.number(),
});

/** 円グラフ用: 当日の注文ステータス別内訳 */
export const DashboardStatusBreakdown = z.object({
  draft: z.number(),
  confirmed: z.number(),
  assigned: z.number(),
  completed: z.number(),
  cancelled: z.number(),
});

/** 棒グラフ用: ドライバー別配送件数 (当日) */
export const DashboardDriverWorkloadEntry = z.object({
  driver_id: z.string(),
  driver_name: z.string(),
  total: z.number(),
  completed: z.number(),
});

export const DashboardStats = z.object({
  orders: DashboardOrderKpi,
  drivers: DashboardDriverKpi,
  pending_reports: z.number(),
  daily_trend: z.array(DailyTrendEntry),
  status_breakdown: DashboardStatusBreakdown,
  by_driver: z.array(DashboardDriverWorkloadEntry),
});
export type DashboardStatsDto = z.infer<typeof DashboardStats>;
export type DailyTrendEntryDto = z.infer<typeof DailyTrendEntry>;
export type DashboardStatusBreakdownDto = z.infer<typeof DashboardStatusBreakdown>;
export type DashboardDriverWorkloadEntryDto = z.infer<typeof DashboardDriverWorkloadEntry>;

export const DashboardStatsInput = z.object({
  date: z.string().optional(),
});
export type DashboardStatsInputDto = z.infer<typeof DashboardStatsInput>;

/**
 * ダッシュボードのアラート種別 (要件定義書 §3.9)。
 * - deviation: 走行距離の申告値に差異がある日報 (±20% 超)
 * - unconfirmed_instruction: ドライバーがまだ確認 (既読) していない配送指示
 * - unsubmitted_report: 出退勤済みだが未提出 (draft のまま) の日報
 */
export const DashboardAlertKind = z.enum([
  "deviation",
  "unconfirmed_instruction",
  "unsubmitted_report",
]);
export type DashboardAlertKindType = z.infer<typeof DashboardAlertKind>;

export const DashboardAlert = z.object({
  kind: DashboardAlertKind,
  title: z.string(),
  text: z.string(),
  time: z.string(),
  ref_id: z.string().nullable(),
});
export type DashboardAlertDto = z.infer<typeof DashboardAlert>;

export const ListDashboardAlertsInput = z.object({
  limit: z.coerce.number().int().min(1).max(50).default(20),
});
export type ListDashboardAlertsInputDto = z.infer<typeof ListDashboardAlertsInput>;
